import { userDate } from 'owa-datetime';
import { Subtodo } from 'owa-todo-types';
import Subtask from '../schema/Subtask';

export function toSubtodo(subtaskItem: Subtask): Subtodo {
    const subtodoItem = {
        ...subtaskItem,
        CompletedDateTime: subtaskItem.CompletedDateTime
            ? userDate(subtaskItem.CompletedDateTime)
            : undefined,
        OrderDateTime: subtaskItem.OrderDateTime ? userDate(subtaskItem.OrderDateTime) : undefined,
    };

    return subtodoItem;
}
